const config = {
  apiGateway: {
    REGION: 'eu-west-1',
    INTERNAL_API_URL: 'https://pgpcf5e4bg.execute-api.eu-west-1.amazonaws.com/prod',
    TARGET_API_URL: 'https://grebizs9zj.execute-api.eu-west-1.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.staging.macquarie.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.2',
    HOSTNAME: 'https://targets.staging.macquarie.forwoodsafety.com'
  }
};

export default config;